var r={px:"S",py:"S",border:"S",borderRadius:"NONE"};export{r as default};
